export default __webpack_public_path__ + "static/media/iconFilter.625eb2fd.svg";